import * as Dimensions from "../constants/photoDimensions";
/**
 *  Transforms a camelCase string to something more adequate for display (example camelCase to Camel Case).
 * @param {string} str
 */
export function normalizeString(str) {
  return (
    str
      // add a space between a lower case and an upper case
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      // add a space before a number
      .replace(/(\d+)/g, " $1")
      // transforms something like BGImage to BG Image
      .replace(/([A-Z])([A-Z])([a-z])/g, "$1 $2$3")
      // Uppercases first letter of every word
      .replace(/ [a-z]/g, str => str.toUpperCase())
      // Uppercase the first letter of the whole name (since it doesn't match the previous regex)
      .replace(/^./, str => str.toUpperCase())
  );
}

/**
 *  Encodes an object into a query params string (example {name: "achref, lastName:"haouech"} becomes "name=achref&lastName=haouech")
 * @param {object} params
 */
export function encodeUrlParams(params) {
  if (params)
    return Object.keys(params)
      .map(key => key + "=" + params[key])
      .join("&");

  return "";
}

export function downloadFile(data, fileName) {
  // We trigger a download by creating a "a" tag with the url of the config and programmatically clicking on it
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
}

/**
 *  Returns an object with the appropriate width and height depending on the mode and the photo ratio
 * @param {*} mode
 * @param {*} ratio
 */
export function getDimensions(mode, photoRatio) {
  if (photoRatio == 1) {
    switch (mode) {
      case "1":
        return {
          dimensions: [
            [Dimensions.PictureWidth, Dimensions.PictureHeight],
            [Dimensions.PictureHeight, Dimensions.PictureWidth]
          ]
        };
      case "2":
        return {
          width: Dimensions.GifWidth,
          height: Dimensions.GifHeight
        };
      default:
        return {
          width: Dimensions.PictureWidth,
          height: Dimensions.PictureHeight
        };
    }
  } else {
    switch (mode) {
      case "1":
        return photoRatio == 0
          ? {
              dimensions: [
                [Dimensions.PictureWidth, Dimensions.PictureHeight],
                [Dimensions.PictureHeight, Dimensions.PictureWidth]
              ]
            }
          : {
              width: Dimensions.PictureHeight,
              height: Dimensions.PictureWidth
            };
      case "2":
        return {
          width: Dimensions.GifHeight,
          height: Dimensions.GifWidth
        };
      default:
        return {
          width: Dimensions.PictureHeight,
          height: Dimensions.PictureWidth
        };
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/utils.js